import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { Form, Card, Typography, Flex, Alert, Select } from 'antd'
import type { FlowEditorContext } from '../../index'
import { downsellRedirectOptions } from '@/data'

const { Title, Text } = Typography

export const DownsellPage: React.FC = () => {
  const { selectedTemplate, downsellId, setDowsellId } =
    useOutletContext<FlowEditorContext>()

  if (!selectedTemplate) {
    return (
      <Alert
        title="No Template Selected"
        description="Please select a template first to edit content."
        type="info"
        showIcon
      />
    )
  }

  return (
    <div>
      <Flex vertical gap="large" style={{ width: '100%' }}>
        <div>
          <Title level={4}>Downsell</Title>
          <Text type="secondary">
            Select the downsell page shown to users who don't qualify for the
            main offer.
          </Text>
        </div>

        <Card title="Select Downsell" style={{ maxWidth: 700 }}>
          <Form layout="vertical">
            <Form.Item label="Downsell Type">
              <Select
                value={downsellId != null ? String(downsellId) : undefined}
                onChange={(value) =>
                  setDowsellId(value != null ? Number(value) : null)
                }
                style={{ width: '100%' }}
                size="large"
                options={downsellRedirectOptions}
                placeholder="Select a downsell..."
              />
            </Form.Item>
          </Form>
        </Card>
      </Flex>
    </div>
  )
}
